'use client';
import { EXIST_LOCAL_STORAGE } from '@/services/constants/app';
import { getStorage } from '@/services/helperFunctions';
import dynamic from 'next/dynamic';
import React, { memo, useEffect, useState } from 'react';
const TradeBroadcastRightBar = dynamic(() => import('@/components/TradeBroadcastRightBar/TradeBroadcastRightBar'), {
    ssr: false,
});

const TradeBroacastWrapper = ({ isLoggedIn }: { isLoggedIn: boolean }) => {
    const userId = getStorage(EXIST_LOCAL_STORAGE.USER_ID);
    const [isUserLoggedIn, setIsUserLoggedIn] = useState(isLoggedIn);
    useEffect(() => {
        setIsUserLoggedIn(!!userId);
    }, [userId]);
    return (
        <div className="col-0 col-lg-2" style={{ paddingTop: '4px' }}>
            <TradeBroadcastRightBar isLoggedIn={isUserLoggedIn} userId={userId} />
        </div>
    );
};

export default memo(TradeBroacastWrapper);
